import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global fetch interceptor to add auth token to all API requests
const originalFetch = window.fetch;
window.fetch = async function(url, options = {}) {
  // Safely get token
  let token = null;
  try {
    token = localStorage.getItem('auth_token');
  } catch (e) {
    // localStorage might not be available
  }
  
  // Only add auth header to our API requests (check url is a string first)
  if (token && typeof url === 'string' && url.includes('/api/')) {
    options = options || {};
    options.headers = {
      ...options.headers,
      'Authorization': `Bearer ${token}`,
    };
  }
  
  return originalFetch(url, options);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
